'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */

var arrayUtils = require('zero-lang/array');
var checkType = require('zero-lang/type');
var fmtDate = require('zero-fmt/date');

var D2JSON = Date.prototype.toJSON;

if (!checkType.isFunction(D2JSON)) {
    arrayUtils.each([String.prototype, Number.prototype, Boolean.prototype], function (p) {
        p.toJSON = function () {
            return this.valueOf();
        };
    });
    D2JSON = function () {
        return isFinite(this.valueOf()) ? fmtDate(this) : null;
    };
}

var undef = undefined;
var escapeString = function escapeString( /*String*/str) {
    return ('"' + str.replace(/(["\\])/g, '\\$1') + '"').replace(/[\f]/g, '\\f').replace(/[\b]/g, '\\b').replace(/[\n]/g, '\\n').replace(/[\t]/g, '\\t').replace(/[\r]/g, '\\r');
};

var json = {
    parse: function parse(str, strict) {
        /*
         * @description: 从 JSON 字符串得到一个数据结构
         */
        if (strict && !/^([\s\[\{]*(?:"(?:\\.|[^"])*"|-?\d[\d\.]*(?:[Ee][+-]?\d+)?|null|true|false|)[\s\]\}]*(?:,|:|$))+$/.test(str)) {
            throw 'Invalid characters in JSON';
        }
        /* jshint -W061 */
        return eval('(' + str + ')');
    },
    stringify: function stringify(value, replacer, spacer) {
        /*
         * @description: 把内置数据类型转为 JSON 字符串
         */
        if (checkType.isString(replacer)) {
            spacer = replacer;
            replacer = null;
        }
        function stringify(it, indent, key) {
            if (replacer) {
                it = replacer(key, it);
            }
            var val = undefined;
            if (checkType.isNumber(it)) {
                return isFinite(it) ? it + '' : 'null';
            }
            if (checkType.isBoolean(it)) {
                return it + '';
            }
            if (it === null) {
                return 'null';
            }
            if (checkType.isString(it)) {
                return escapeString(it);
            }
            if (checkType.isFunction(it) || !it) {
                return undef;
            }
            if (checkType.isFunction(it.toJSON)) {
                return stringify(it.toJSON(key), indent, key);
            }
            if (checkType.isDate(it)) {
                return fmtDate(it);
            }
            if (it.valueOf() !== it) {
                return stringify(it.valueOf(), indent, key);
            }
            var nextIndent = spacer ? indent + spacer : '';
            var sep = spacer ? ' ' : '';
            var newLine = spacer ? '\n' : '';

            if (checkType.isArray(it)) {
                var itl = it.length;
                var res = [];
                for (key = 0; key < itl; key++) {
                    var obj = it[key];
                    val = stringify(obj, nextIndent, key);
                    if (!checkType.isString(val)) {
                        val = 'null';
                    }
                    res.push(newLine + nextIndent + val);
                }
                return '[' + res.join(',') + newLine + indent + ']';
            }
            var output = [];
            for (key in it) {
                var keyStr = undefined;
                if (it.hasOwnProperty(key)) {
                    if (checkType.isNumber(key)) {
                        keyStr = '"' + key + '"';
                    } else if (checkType.isString(key)) {
                        keyStr = escapeString(key);
                    } else {
                        continue;
                    }
                    val = stringify(it[key], nextIndent, key);
                    if (!checkType.isString(val)) {
                        continue;
                    }
                    output.push(newLine + nextIndent + keyStr + ':' + sep + val);
                }
            }
            return '{' + output.join(',') + newLine + indent + '}';
        }
        return stringify(value, '', '');
    }
};

// comment this code block to test {
if (typeof JSON !== 'undefined' && JSON && !!JSON.parse && !!JSON.stringify) {
    json = JSON;
}
// }

module.exports = json;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-net/~/zero-encoding/json.js
 ** module id = 14
 ** module chunks = 0 1
 **/